import React, { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { ITepOfficer } from 'types/tep';
import { Tooltip } from 'components/atoms/tooltip';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { actions } from 'core/redux/api/veta/tep/officers';
import { close, deleteIcon, edit2, save } from 'assets/icons';
import { officersCellSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IActionsProps {
  officer: ITepOfficer;
}

export const Actions: FC<IActionsProps> = ({ officer }) => {
  const dispatch = useDispatch();

  const { id, intent } = useSelector(officersCellSelector);

  const { handleSubmit } = useFormContext<{ phone: string; remarks: string }>();

  const isSelected = officer?.id === id;

  const onEdit = () => {
    dispatch(actions.edit({ id: officer.id }));
  };

  const onCancel = () => dispatch(actions.cancel());

  const onSave = () => {
    handleSubmit((data) => {
      intent === 'add' ? dispatch(actions.add.request(data)) : dispatch(actions.update.request({ id, data }));
    })();
  };

  const onRemove = () => dispatch(actions.remove.request({ id: officer.id }));

  return (
    <div className={styles.actions}>
      {isSelected ? (
        <>
          <Tooltip text="save">
            <SvgWrapper width={24} height={24} details={save} onClick={onSave} />
          </Tooltip>
          <Tooltip text="close without saving">
            <SvgWrapper width={24} height={24} details={close} onClick={onCancel} />
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip text="edit">
            <SvgWrapper width={24} height={24} details={edit2} onClick={onEdit} />
          </Tooltip>
          <Tooltip text="remove">
            <SvgWrapper className={styles.remove} width={20} height={20} details={deleteIcon} onClick={onRemove} />
          </Tooltip>
        </>
      )}
    </div>
  );
};
